import { Container, Row, Col, Card } from 'react-bootstrap';


const WhatCanYouLend = () => {
  const categories = [
    {
      
      name: "Photography",
      description: "Cameras, lenses, tripods",
      earnings: "₹4,000-16,000/day"
    },
    {
      
      name: "Tools & Equipment",
      description: "Power Tools, Ladders, Generators",
      earnings: "₹2,500-12,000/day"
    },
    {
      
      name: "Outdoor Gear",
      description: "Tents, Bikes, Kayaks", 
      earnings: "₹2,000-8,000/day"
    },
    {
      
      name: "Electronics",
      description: "Gaming consoles, speakers",
      earnings: "₹1,500-6,500/day"
    },
    {
      
      name: "Party & Events", 
      description: "Tables, chairs, decorations",
      earnings: "₹1,200-6,000/day"
    },
    {
      
      name: "Sports Equipment",
      description: "Golf Clubs, Skis, Surfboards",
      earnings: "₹1,500-10,000/day"
    },
    {
      
      name: "Home & Garden",
      description: "Pressure Washers, Lawn Mowers",
      earnings: "₹2,000-7,500/day"
    },
    {
      
      name: "Transportation",
      description: "Bikes, Scooters, Car Accessories",
      earnings: "₹800-5,000/day"
    }
  ];

  return (
    <section id="categories" className="section-padding" style={{backgroundColor: 'white'}}>
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold mb-4" style={{color: 'var(--text-dark)', letterSpacing:'-2.4px'}}>
            What Can You Lend?
          </h2>
          <p className="text-gray fs-5" >
            A world where all types of stuff gets shared
          </p>
        </div>

        <Row className="g-4">
          {categories.map((category, index) => {
            return (
              <Col sm={6} lg={3} key={index}>
                <Card className="h-100   card-hover" style={{cursor: 'pointer', border:'1px solid #E4E4E7'}}>
                  <Card.Body className="p-4">
                    
                    <Card.Title className=" fw-semibold mb-2" style={{color: 'var(--text-dark)', fontSize:"18px"}}>
                      {category.name}
                    </Card.Title>
                    <Card.Text className="small mb-3" style={{color: 'var(--text-muted)'}}>
                      {category.description}
                    </Card.Text>
                    <div className="fw-semibold text-green" >
                      {category.earnings}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default WhatCanYouLend;